import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, unref as _unref, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { reactive, computed, ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { Modal as AModal } from 'ant-design-vue'
import Modal from '@/hooks/modalType'
import { message } from '@dc-platform/dc-components'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import { planStatusEnum, remindTypeEnum, customerStageEnum } from '../dataConfig'
import { listByParamCodes } from '@/api/common'
import {
  visitorProgramList,
  visitorProgramCancel,
  visitorProgramDelete,
  visitorProgramDetail
} from '@/api/yuntuSales/followUpManage'
import { customerListFormat } from '@/utils'
import type { ParamCodeItem } from '@/typings/common'
import type { LbuVisitorProgramParams, LbuVisitorProgramListItem } from '@/typings/api/followUpManage'

const __default__ = { name: 'DcCosLbuVisitorProgram' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter()

// 计划状态枚举
const planStatusEnumAll = [{ label: '全部', value: undefined }, ...planStatusEnum]
const statusEnum = planStatusEnum.map((item) => ({
  name: item.label,
  value: item.value,
  color: item.color
}))
// 时间类型枚举
const timeTypeEnum = [
  { label: '创建时间', value: 0 },
  { label: '计划拜访时间', value: 1 }
]
const paramCodeData: {
  [key: string]: ParamCodeItem[]
} = reactive({
  lbu_follow_purpose: [], // 拜访目的
  lbu_follow_mode: [] // 拜访方式（跟进方式）
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: ['lbu_follow_purpose', 'lbu_follow_mode']
  }).then((res) => {
    Object.assign(paramCodeData, res.data)
  })
}
onMounted(() => {
  getByParamCodes()
})

const tableRef = ref()
const queryForm = reactive<LbuVisitorProgramParams>({ timeType: 0 })

const columns = computed(() => [
  {
    title: '计划标题',
    dataIndex: 'title',
    cosType: 'link',
    path: '/lbu/visitorProgram/view',
    query: ['id'],
    fixed: 'left',
    width: 200
  },
  { title: '客户代码', dataIndex: 'tmsCode' },
  { title: '客户名称', dataIndex: 'customerName', width: 200 },
  { title: '客户ID', dataIndex: 'visitRefId', width: 200 },
  { title: '客户阶段', dataIndex: 'customerStage', dicData: customerStageEnum },
  { title: '拜访方式', dataIndex: 'mode', dicData: paramCodeData.lbu_follow_mode },
  { title: '计划拜访时间', dataIndex: ['startTime', 'endTime'], cosType: 'timeRange', width: 320, sorter: true },
  { title: '实际拜访时间', dataIndex: 'finishTime', width: 190, sorter: true },
  { title: '拜访目的', dataIndex: 'purpose', dicData: paramCodeData.lbu_follow_purpose },
  { title: '联系人姓名', dataIndex: 'contactName', cosType: 'mask' },
  { title: '手机号', dataIndex: 'contactMobile', cosType: 'mask' },
  { title: '地址', dataIndex: 'customerAddress' },
  { title: '状态', dataIndex: 'status' },
  { title: '提醒计划', dataIndex: 'remindType', dicData: remindTypeEnum },
  { title: '提醒时间', dataIndex: 'remindTime' },
  { title: '备注', dataIndex: 'remark' },
  { title: '创建人', dataIndex: 'createByName' },
  { title: '创建时间', dataIndex: 'createTime', width: 190, sorter: true },
  { title: '更新人', dataIndex: 'updateByName' },
  { title: '更新时间', dataIndex: 'updateTime', width: 190, sorter: true },
  { title: '操作', dataIndex: 'action', width: 200, fixed: 'right' }
])
const getList = (queryForm: LbuVisitorProgramParams, callBack: (res: any) => void) => {
  const params = customerListFormat(queryForm) // 处理客户名称和客户编码的批量查询参数
  const cosId = queryForm.cosId
  if (cosId !== undefined && cosId.length > 0) {
    params.cosIdList = cosId.split(' ')
    params.cosId = undefined
  }
  visitorProgramList(params).then((res) => {
    callBack(res)
  })
}
const showMask = (record: LbuVisitorProgramListItem, callBack: (res: any) => void) => {
  visitorProgramDetail(record.id).then((res) => {
    callBack(res.data)
  })
}
const handleQueryChange = (type?: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}

// 新增编辑函数
const triggerAddOrEdit = (id?: string) => {
  if (id) {
    router.push({ path: '/lbu/visitorProgram/edit', query: { id } })
  } else {
    router.push('/lbu/visitorProgram/add')
  }
}
const handleVisitComplete = (row: LbuVisitorProgramListItem) => {
  router.push({ path: '/lbu/followUpRecord/visitingPlan', query: { planId: row.id } })
}
const handleCancel = (row: LbuVisitorProgramListItem) => {
  AModal.warning({
    closable: true,
    title: '确定取消计划吗？',
    content: `取消【${row.title}】，取消后不可进行其他操作，请谨慎操作。`,
    okCancel: true,
    cancelText: '取消',
    okText: '确定',
    onOk() {
      visitorProgramCancel(row.id).then(() => {
        message.success('取消计划成功')
        tableRef.value?.fetch()
      })
    }
  })
}

const handleDelete = (row: LbuVisitorProgramListItem) => {
  Modal.delete({
    name: row.title,
    onOk() {
      visitorProgramDelete(row.id).then(() => {
        message.success('删除计划成功')
        tableRef.value?.delFetch()
      })
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_CosRangePicker = _resolveComponent("CosRangePicker")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_dc_status = _resolveComponent("dc-status")!
  const _component_SellerButton = _resolveComponent("SellerButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, { "is-breadcrumb": true }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            search: queryForm,
            "onUpdate:search": _cache[15] || (_cache[15] = ($event: any) => ((queryForm) = $event)),
            onFetch: getList,
            onMask: showMask,
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "DcCosLbuVisitorProgram"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    label: "客户名称",
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_textarea, {
                        value: queryForm.customerName,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.customerName) = $event)),
                        autoSize: { minRows: 1, maxRows: 4 },
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    label: "客户代码",
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_textarea, {
                        value: queryForm.tmsCode,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.tmsCode) = $event)),
                        autoSize: { minRows: 1, maxRows: 4 },
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "计划状态" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio_group, {
                        value: queryForm.status,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.status) = $event)),
                        optionType: "button",
                        options: planStatusEnumAll,
                        onChange: _cache[3] || (_cache[3] = ($event: any) => (handleQueryChange('search')))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户负责人" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UserSelect, {
                        permission: "",
                        value: queryForm.dutyByList,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.dutyByList) = $event)),
                        placeholder: "请选择",
                        mode: "multiple",
                        allowClear: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "联系人姓名" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.contactName,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.contactName) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 100,
                        placeholder: "请输入",
                        allowClear: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "手机号" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.contactMobile,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.contactMobile) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 100,
                        placeholder: "请输入",
                        allowClear: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户区域" }, {
                    default: _withCtx(() => [
                      _createVNode(CustomerAreaCascader, {
                        type: "search",
                        appId: "cos_lbu",
                        ids: queryForm.areaIdList,
                        "onUpdate:ids": _cache[7] || (_cache[7] = ($event: any) => ((queryForm.areaIdList) = $event))
                      }, null, 8, ["ids"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "员工区域" }, {
                    default: _withCtx(() => [
                      _createVNode(CustomerAreaCascader, {
                        type: "search",
                        appId: "cos_lbu",
                        ids: queryForm.employeeRegionList,
                        "onUpdate:ids": _cache[8] || (_cache[8] = ($event: any) => ((queryForm.employeeRegionList) = $event))
                      }, null, 8, ["ids"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "时间查询" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_group, { compact: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: queryForm.timeType,
                            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((queryForm.timeType) = $event)),
                            options: timeTypeEnum,
                            style: {"width":"33%"}
                          }, null, 8, ["value"]),
                          _createVNode(_component_CosRangePicker, {
                            startTime: queryForm.startTime,
                            "onUpdate:startTime": _cache[10] || (_cache[10] = ($event: any) => ((queryForm.startTime) = $event)),
                            endTime: queryForm.endTime,
                            "onUpdate:endTime": _cache[11] || (_cache[11] = ($event: any) => ((queryForm.endTime) = $event)),
                            style: {"width":"67%"}
                          }, null, 8, ["startTime", "endTime"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户ID" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.cosId,
                        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((queryForm.cosId) = $event)),
                        maxlength: 100,
                        placeholder: "请输入",
                        allowClear: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "拜访方式" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ParamCodesSelect, {
                        value: queryForm.mode,
                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((queryForm.mode) = $event)),
                        options: paramCodeData.lbu_follow_mode,
                        allowClear: ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (triggerAddOrEdit()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("新增")
                ]),
                _: 1
              })), [
                [_directive_permission, 'lbu_visitor_add_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_ExportButton, {
                appId: "cos_lbu",
                taskType: "307",
                search: _unref(customerListFormat)(queryForm)
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导出")
                ]),
                _: 1
              }, 8, ["search"])), [
                [_directive_permission, 'lbu_visitor_export_btn']
              ])
            ]),
            bodyCell: _withCtx(({ column, record, text }) => [
              (column.dataIndex === 'status')
                ? (_openBlock(), _createBlock(_component_dc_status, {
                    key: 0,
                    enums: _unref(statusEnum),
                    value: text
                  }, null, 8, ["enums", "value"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'action')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                      type: "link",
                      workCode: record.dutyBy,
                      disabled: [3, 4].includes(record.status),
                      onClick: ($event: any) => (handleVisitComplete(record))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("完成计划")
                      ]),
                      _: 2
                    }, 1032, ["workCode", "disabled", "onClick"])), [
                      [_directive_permission, 'lbu_visitor_complete_btn']
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                      type: "link",
                      workCode: record.dutyBy,
                      disabled: [3, 4].includes(record.status),
                      onClick: ($event: any) => (handleCancel(record))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("取消")
                      ]),
                      _: 2
                    }, 1032, ["workCode", "disabled", "onClick"])), [
                      [_directive_permission, 'lbu_visitor_cancel_btn']
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                      type: "link",
                      disabled: [3, 4].includes(record.status),
                      onClick: ($event: any) => (handleDelete(record))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"])), [
                      [_directive_permission, 'lbu_visitor_del_btn']
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "search"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})